<template >
  <b-container fluid>
    <b-row class="mt-2 mb-2">
      <b-col >
        <b-input-group  class="mb-2">
          <b-form-input
            v-model="contrato"
            style="text-align: center; font-weight: bold;"
            type="search"
            placeholder="Contrato, no. de cuenta ..."
            @keyup.enter="consultaRecorrido"
          ></b-form-input>
          <b-input-group-prepend is-text>
            <b-icon icon="search" :animation="registrando?'spin-pulse':''" style="cursor:pointer" @click="consultaRecorrido"></b-icon>
          </b-input-group-prepend>          
        </b-input-group>
      </b-col>        
    </b-row>
    <b-row align-h="center" align="center" v-if="registro!=null  ">
      <b-col cols="12"><h5><b-icon icon="upc-scan"/> {{registro.medidor}}</h5></b-col>
      <b-col cols="12"><h6 style="color:gray"><b-icon icon="house-fill"/> {{registro.ubicacion}}</h6></b-col>
      <b-col cols="12"><h6 style="color:gray"><b-icon icon="person-fill"/> {{registro.nombre}}</h6></b-col>
    </b-row>
    <b-row align-h="center" align="center" class="mt-3" v-if="registro!=null  ">
      <b-col><b-icon icon="calendar3"/><b> {{registro.periodoAnterior}}</b></b-col>
      <b-col><b-icon icon="clipboard-check"/><b> {{registro.lecturaAnterior}}</b></b-col>
      <b-col><b-icon icon="droplet-half"/><b> {{registro.consumoAnterior}}</b></b-col>
      <b-col cols="12" class="mb-2"><span style="color:gray">{{registro.anomaliaAnterior}}</span></b-col>
    </b-row>


    <b-row style="color:green; " align-h="center" align="center" class="mt-3" v-if="registro!=null && registro.cargado">
      <b-col><b-icon icon="calendar3"/><b> {{registro.periodoActual}}</b></b-col>
      <b-col><b-icon icon="clipboard-check"/><b> {{registro.lecturaActual}}</b></b-col>
      <b-col><b-icon icon="droplet-half"/><b> {{registro.consumoActual}}</b></b-col>
      <b-col cols="12" class="mb-2"><span style="color:gray">{{registro.anomaliaActual}}</span></b-col>
      <b-col cols="12" class="mb-2"><span style="color:gray">{{registro.obsActual}}</span></b-col>

      <b-col cols="12"><b-button @click="borrarRegistro" variant="link">Borrar registro {{registro.periodoActual}} <b-icon icon="trash" font-scale=".9" shift-v="2"/></b-button></b-col>
      <b-col cols="12" class="mt-2">
        <b-button block size="lg" variant="success" @click="showOrden = true" v-if="this.registro!=null && this.registro.orden!=null && this.registro.orden!=''">FORMATO DE PAGO <b-spinner v-if="registrando" /></b-button>
      </b-col>
    </b-row>


    <b-row align-h="center" align="center" class="mt-4" v-if="registro!=null && !registro.cargado">
      <b-col cols="12">
        <h5 style="color:green">Periodo {{registro.periodoActual}}</h5>
      </b-col>
      <b-col cols="12"><b-form-input placeholder="Ingrese lectura aquí" @keyup="calculaConsumo" type="number" size="lg" v-model="registro.lecturaActual" style="text-align: center; font-weight: bold; background-color: azure;"></b-form-input></b-col>
      <!-- <b-col cols="12" class="mt-3 mb-3"><h5 style="color:gray">Consumo: {{registro.consumoActual}} m3</h5></b-col> -->
      <b-col cols="12"><b-form-select size="lg" :options="anomalias" v-model="registro.anomaliaActual"></b-form-select></b-col>
      

      <!-- <b-col cols="12"  v-if="registro.fotoActual==''" class="mt-2">
        <b-form-file  @change="saveFotoMedidorToB64" size="sm" accept="image/jpeg, image/png, image/jpg" placeholder="Ingrese la foto del medidor ..." drop-placeholder="Arrastre el archivo aquí..."  />
      </b-col>
      <b-col cols="12" md="7" v-if="registro.fotoActual!=''" class="mt-2">
        <b-img fluid  :src="registro.fotoActual"></b-img><b-button v-if="registro.fotoActual!=''" @click="registro.fotoActual=''" variant="link">Borrar <b-icon icon="trash" font-scale=".9" shift-v="2"/></b-button>
      </b-col> -->

      <b-col cols="12" class="mt-3">
        <div v-if="!fotoTomada">
          <b-button
            variant="warning"
            class="mb-2"
            @click="abrirCamara"
            block
            :disabled="registrando"
          >
            Captura Foto
          </b-button>
        </div>

        <canvas ref="canvas" style="display: none;"></canvas>

        <div v-if="fotoTomada">
          <div class="text-center">
            <b-img
              :src="imagenBase64"
              fluid
              rounded
              alt="Foto capturada"
              class="preview-img border"
            ></b-img>
          </div>

          <div class="mt-3">
            <b-button variant="outline-info" class="mr-2 mb-2" @click="repetirFoto">
              Tomar otra foto
            </b-button>

            <b-button variant="outline-danger" class="mb-2" @click="borrarFoto">
              Borrar foto
            </b-button>
          </div>
        </div>
      </b-col>



      <b-col cols="12" class="mt-3">
        <b-button
          block
          size="lg"
          variant="success"
          @click="registrar"
          :disabled="registrando"
        >
          REGISTRAR CONSUMO <b-spinner v-if="registrando" />
        </b-button>
      </b-col>
      
    </b-row>
    <b-row>
      <b-modal v-model="showOrden" title="Formato de Pago" header-bg-variant="dark" header-text-variant="light" hide-footer>
        <b-row v-if="this.registro!=null && this.registro.orden!=null && this.registro.orden!=''">
          <b-col>
            <b-img fluid  :src="'data:image/png;base64,'+registro.orden"></b-img>
          </b-col>
          <b-col cols="12">
            <b-button block variant="info" @click="descargaOrden">DESCARGAR <b-icon icon="printer-fill" /></b-button>
          </b-col>
        </b-row>
      </b-modal>
    </b-row>

    <b-modal
      v-model="showCamaraModal"
      title="Captura de foto"
      centered
      hide-footer
      modal-class="modal-camara"
      content-class="modal-camara-content"
      body-class="p-2"
      no-close-on-backdrop
      @hidden="onModalCamaraHidden"
    >
      <div class="text-center">
        <video
          ref="video"
          autoplay
          playsinline
          muted
          class="video-preview border rounded"
        ></video>
       <input
        ref="inputCamaraSistema"
        type="file"
        accept="image/*"
        capture="environment"
        style="display:none"
        @change="seleccionarFotoDesdeArchivo"
      />

      <input
        ref="inputGaleria"
        type="file"
        accept="image/*"
        style="display:none"
        @change="seleccionarFotoDesdeArchivo"
      />
      </div>

      <div class="mt-3 text-center">
        <b-button
          variant="info"
          size="lg"
          class="mr-2 mb-2"
          @click="capturarFoto"
          v-if="camaraAbierta && !fotoTomada"
        >
          <b-icon icon="camera-fill"/> Capturar
        </b-button>

        

        <b-button
          variant="outline-info"
          class="mr-2 mb-2"
          @click="repetirFoto"
          v-if="fotoTomada"
        >
          Tomar otra foto
        </b-button>

        <b-button
          variant="outline-danger"
          class="mb-2"
          @click="borrarFoto"
          v-if="fotoTomada"
        >
          Borrar foto
        </b-button>

        <b-button
          variant="warning"
          size="lg"
          class="mr-2 mb-2"
          @click="abrirCamaraSistema"
          v-if="!fotoTomada"
        >
          <b-icon icon="camera"/> Avanzada
        </b-button>

        <b-button
          variant="secondary"
          size="lg"
          class="mr-2 mb-2"
          @click="abrirGaleria"
          v-if="!fotoTomada"
        >
          <b-icon icon="image-fill"/> Galería
        </b-button>

        <b-button
          variant="danger"
          size="lg"
          class="mr-2 mb-2"
          @click="cerrarModalCamara"
          v-if="camaraAbierta && !fotoTomada"
        >
          Cancelar <b-icon icon="x-circle-fill"/>
        </b-button>

      </div>

      <div v-if="error" class="text-danger text-center mt-2">
        {{ error }}
      </div>
    </b-modal>
  </b-container>


</template>

<script>
  //import { Html5Qrcode } from "html5-qrcode";
  import { mapState} from 'vuex';
  import axios from 'axios';
  //import { minLength, maxLength, required, between } from 'vuelidate/lib/validators';
  import { server, checkAuth, getPostConfig, handledError } from '@/axios-tools';

  export default {
    props: ['contribuyenteActual', 'isAgregarContrib', 'tipoPadron', 'accionPostAgregar'],
    computed: {
      ...mapState({
        token: state => state.login.token,
        catTipoPadronesAgregar: state => state.padrones.catalogoPadrones.tipoPadronesAgregar,
        catalogoPadrones: state => state.padrones.catalogoPadrones,
      }),
      
    },
    mounted(){
      if(window.matchMedia("(max-width: 768px)").matches){
        this.$store.commit("updateIsShowSideCobro", false);
        
      }
      window.scrollTo(0, 0);
    },
    components:{
    },
    data() {
      return {
       
        /*
        registro:{
          nombre:"ANA MARIA LOPEZ HERNANDEZ",
          ubicacion:"AV DE LOS FERROCARILES, COL CENTRO, SAN MARTIN TEXMELUCAN PUEBLA MEX",
          medidor:"IUSA-512681221",
          periodoAnterior:"2024/6",
          lecturaAnterior:"15622",
          consumoAnterior:"25",
          anomaliaAnterior:"",
          fotoAnterior:"",
          periodoActual:"2024/6",
          lecturaActual:"15622",
          consumoActual:"25",
          anomaliaActual:"",
          fotoActual:"",
          anomalias:["","MEDIDOR DESCOMPUESTO"],
          cargado:true
        }*/
        showOrden:false,
        registrando:false,
        contrato:'',
        registro:null,
        anomalias:[
          {value:'', text:'SIN ANOMALÍA'},
          'CASA CERRADA',
          'CASA DESHABITADA',
          'LA MASCOTA NO PERMITIO LA TOMA DE LECTURA',
          'LECTURA ILEGIBLE',
          'MEDIDOR DESCOMPUESTO',
          'MEDIDOR DETENIDO',
          'MEDIDOR INVERTIDO',
          'MEDIDOR ROTO',
          'NO PERMITIERON LA TOMA DE LECTURA',
          'SERVICIO SIN MEDIDOR',
          'TERRENO BALDIO SIN TOMA',
          'TOMA RESTRINGIDA',
          'VUELTA DE MEDIDOR',
        ],

        stream: null,
        camaraAbierta: false,
        imagenBase64: "",
        fotoTomada: false,
        showCamaraModal: false,
        error: ""
      }

    },
    methods: {
      /*
      calculaConsumo(){
        let consumo = this.registro.lecturaActual - parseFloat(this.registro.lecturaAnterior);
        this.registro.consumoActual = consumo;
      },*/
      calculaConsumo() {
        if (!this.registro) return;

        const lecturaAnterior = Number(this.registro.lecturaAnterior || 0);
        const lecturaActual = Number(this.registro.lecturaActual || 0);

        if (this.registro.lecturaActual === '' || this.registro.lecturaActual === null || this.registro.lecturaActual === undefined) {
          this.registro.consumoActual = '';
          return;
        }

        let consumo = lecturaActual - lecturaAnterior;

        if (isNaN(consumo)) {
          this.registro.consumoActual = '';
          return;
        }

        if (consumo < 0) {
          consumo = 0;
        }

        this.registro.consumoActual = consumo;
      },
      registrar(){
          
        if(!this.registrando && checkAuth(this.$router, this.$store) && this.registro.lecturaActual!=''){
          this.registrando = true;

          axios(
            getPostConfig(server.registrarecorridoagua, this.registro, this.token, {})        
          )
          .then(res => {
            window.scrollTo(0, 0);
            this.registro = res.data;
            this.registrando = false;
            if(this.registro.orden!=null && this.registro.orden!=''){
              this.showOrden = true;
            }

          }).catch(err => {
              alert(err);
              this.registrando = false;
          });
        }
      },
      consultaRecorrido(){
        if(!this.registrando && checkAuth(this.$router, this.$store) && this.contrato!=''){
          this.registrando = true;

          axios(
            getPostConfig(server.recorridoactualagua, {}, this.token, {contrato:this.contrato})        
          )
          .then(res => {
            this.resetEstadoFoto();
            this.registro = res.data;
            this.registrando = false;
            if(this.registro.orden!=null && this.registro.orden!=''){
              this.showOrden = true;
            }
          }).catch(err => {
              handledError(err, server.recorridoactualagua, this.$router, this.$store)


              this.registrando = false;
          });
        }
      },
      borrarRegistro(){
        if (!this.registro) return;

        this.registro.cargado = false;
        this.registro.fotoActual = "";
        this.registro.coordenada = "";
        this.resetEstadoFoto();
      },
      descargaOrden(){
        let img= 'data:image/png;base64,'+this.registro.orden;      
                var downloadPdf = document.createElement('a');
                downloadPdf.setAttribute('href', img);
                downloadPdf.setAttribute('download', this.registro.contrato+"_"+Date.now()+".png");
                downloadPdf.click(); 
      },
      saveFotoMedidorToB64(evt){
         //this.$store.commit("updateIsWorking", true);
        var f = evt.target.files[0];
        var reader = new FileReader();
        //Creamos una refrencia local al objeto this para poder acceder desde las funciones anidadas a los objetos cliente, token .. etc
        var thisObject = this;
        reader.onload = function (e) {
            var img = document.createElement("img");
            img.onload = function () {
                var MAX_WIDTH = 465;
                var MAX_HEIGHT = 465;

                var width = img.width;
                var height = img.height;

                // Change the resizing logic
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height = height * (MAX_WIDTH / width);
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width = width * (MAX_HEIGHT / height);
                        height = MAX_HEIGHT;
                    }
                }
                // Dynamically create a canvas element
                var canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                // var canvas = document.getElementById("canvas");
                var ctx = canvas.getContext("2d");

                // Actual resizing
                ctx.drawImage(img, 0, 0, width, height);

                // Show resized image in preview element
                var dataurl = canvas.toDataURL(f.type);
                thisObject.registro.fotoActual = dataurl;
            }
            img.src = e.target.result;
        }
        reader.onerror = function(error){
          alert("error al cargar archivo"+error);
        };
        reader.readAsDataURL(f);

        //Se guarda la ubicacion
        navigator.geolocation.getCurrentPosition(
          function success(pos) {
            const crd = pos.coords;
            thisObject.registro.coordenada=crd.latitude+','+crd.longitude
          }, 
          function error(err) {
            alert(`ERROR(${err.code}): ${err.message}`);
          }, 
           {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          });

      },





      /**Para camara de foto de medidor */
      async abrirCamara() {
        if (this.camaraAbierta || this.registrando) return;

        this.error = "";

        try {
          if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            this.error = "Este navegador no soporta acceso a la cámara.";
            return;
          }

          this.showCamaraModal = true;

          this.stream = await navigator.mediaDevices.getUserMedia({
            video: {
              facingMode: { ideal: "environment" }
            },
            audio: false
          });

          this.camaraAbierta = true;

          this.$nextTick(() => {
            if (this.$refs.video) {
              this.$refs.video.srcObject = this.stream;
              this.$refs.video.play().catch(() => {});
            }
          });

        } catch (e) {
          this.error = "No fue posible acceder a la cámara. Verifica permisos y usa HTTPS o localhost.";
          this.showCamaraModal = false;
          this.cerrarCamara();
        }
      },

        capturarFoto() {
          try {
            const video = this.$refs.video;
            const canvas = this.$refs.canvas;

            if (!video || !canvas) {
              this.error = "No se encontró el video o el canvas.";
              return;
            }

            const width = video.videoWidth;
            const height = video.videoHeight;

            if (!width || !height) {
              this.error = "La cámara aún no está lista. Intenta nuevamente.";
              return;
            }

            const MAX_WIDTH = 800;
            const QUALITY = 0.7;

            let newWidth = width;
            let newHeight = height;

            if (width > MAX_WIDTH) {
              const ratio = MAX_WIDTH / width;
              newWidth = MAX_WIDTH;
              newHeight = height * ratio;
            }

            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, newWidth, newHeight);

            this.imagenBase64 = canvas.toDataURL("image/jpeg", QUALITY);
            this.registro.fotoActual = this.imagenBase64;
            this.fotoTomada = true;

            navigator.geolocation.getCurrentPosition(
              (pos) => {
                const crd = pos.coords;
                this.registro.coordenada = crd.latitude + ',' + crd.longitude;
              },
              (err) => {
                alert(`ERROR(${err.code}): ${err.message}`);
              },
              {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
              }
            );

            this.cerrarCamara();
            this.showCamaraModal = false;

          } catch (e) {
            this.error = "Ocurrió un error al capturar la foto.";
          }
        },

        cerrarCamara() {
          if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
          }

          if (this.$refs.video) {
            this.$refs.video.srcObject = null;
          }

          this.camaraAbierta = false;
        },
        cerrarModalCamara() {
          this.cerrarCamara();
          this.showCamaraModal = false;
        },
        onModalCamaraHidden() {
          this.cerrarCamara();
        },

        repetirFoto() {
          this.imagenBase64 = "";
          this.fotoTomada = false;
          this.error = "";

          if (this.registro) {
            this.registro.fotoActual = "";
            this.registro.coordenada = "";
          }

          this.abrirCamara();
        },

        borrarFoto() {
          this.imagenBase64 = "";
          this.fotoTomada = false;
          this.error = "";
          if (this.registro) {
            this.registro.fotoActual = "";
            this.registro.coordenada = "";
          }
          this.cerrarCamara();
          this.showCamaraModal = false;
        },
        resetEstadoFoto() {
          this.imagenBase64 = "";
          this.fotoTomada = false;
          this.error = "";
          this.showCamaraModal = false;
          this.cerrarCamara();
        },

        obtenerBase64Puro() {
          if (!this.imagenBase64) return "";
          return this.imagenBase64.split(",")[1];
        },
        abrirCamaraSistema() {
          this.error = "";

          if (this.$refs.inputCamaraSistema) {
            this.$refs.inputCamaraSistema.value = null;
            this.$refs.inputCamaraSistema.click();
          }
        },

        abrirGaleria() {
          this.error = "";

          if (this.$refs.inputGaleria) {
            this.$refs.inputGaleria.value = null;
            this.$refs.inputGaleria.click();
          }
        },

        seleccionarFotoGaleria(evt) {
          try {
            if (!this.registro) {
              this.error = "No hay un registro activo.";
              return;
            }

            const file = evt.target.files && evt.target.files[0];
            if (!file) return;

            if (!file.type || file.type.indexOf('image/') !== 0) {
              this.error = "El archivo seleccionado no es una imagen válida.";
              return;
            }

            const reader = new FileReader();

            reader.onload = (e) => {
              const img = document.createElement("img");

              img.onload = () => {
                const MAX_WIDTH = 800;
                const QUALITY = 0.7;

                let width = img.width;
                let height = img.height;

                if (width > MAX_WIDTH) {
                  const ratio = MAX_WIDTH / width;
                  width = MAX_WIDTH;
                  height = height * ratio;
                }

                const canvas = this.$refs.canvas;
                if (!canvas) {
                  this.error = "No se encontró el canvas.";
                  return;
                }

                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                this.imagenBase64 = canvas.toDataURL("image/jpeg", QUALITY);
                this.registro.fotoActual = this.imagenBase64;
                this.fotoTomada = true;

                navigator.geolocation.getCurrentPosition(
                  (pos) => {
                    if (!this.registro) return;
                    const crd = pos.coords;
                    this.registro.coordenada = crd.latitude + ',' + crd.longitude;
                  },
                  () => {
                    // opcional: no bloquear si falla ubicación
                  },
                  {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0
                  }
                );

                this.cerrarCamara();
                this.showCamaraModal = false;
              };

              img.onerror = () => {
                this.error = "No fue posible procesar la imagen seleccionada.";
              };

              img.src = e.target.result;
            };

            reader.onerror = () => {
              this.error = "Ocurrió un error al leer la imagen.";
            };

            reader.readAsDataURL(file);
          } catch (e) {
            this.error = "Ocurrió un error al seleccionar la imagen.";
          }
        },

        seleccionarFotoDesdeArchivo(evt) {
          try {
            if (!this.registro) {
              this.error = "No hay un registro activo.";
              return;
            }

            const file = evt.target.files && evt.target.files[0];
            if (!file) return;

            if (!file.type || file.type.indexOf('image/') !== 0) {
              this.error = "El archivo seleccionado no es una imagen válida.";
              return;
            }

            const reader = new FileReader();

            reader.onload = (e) => {
              const img = document.createElement("img");

              img.onload = () => {
                const MAX_WIDTH = 800;
                const QUALITY = 0.7;

                let width = img.width;
                let height = img.height;

                if (width > MAX_WIDTH) {
                  const ratio = MAX_WIDTH / width;
                  width = MAX_WIDTH;
                  height = height * ratio;
                }

                const canvas = this.$refs.canvas;
                if (!canvas) {
                  this.error = "No se encontró el canvas.";
                  return;
                }

                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                this.imagenBase64 = canvas.toDataURL("image/jpeg", QUALITY);
                this.registro.fotoActual = this.imagenBase64;
                this.fotoTomada = true;

                navigator.geolocation.getCurrentPosition(
                  (pos) => {
                    if (!this.registro) return;
                    const crd = pos.coords;
                    this.registro.coordenada = crd.latitude + ',' + crd.longitude;
                  },
                  () => {},
                  {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0
                  }
                );

                this.cerrarCamara();
                this.showCamaraModal = false;
              };

              img.onerror = () => {
                this.error = "No fue posible procesar la imagen seleccionada.";
              };

              img.src = e.target.result;
            };

            reader.onerror = () => {
              this.error = "Ocurrió un error al leer la imagen.";
            };

            reader.readAsDataURL(file);
          } catch (e) {
            this.error = "Ocurrió un error al seleccionar la imagen.";
          }
},
        
        
        
        

      },

     beforeDestroy() {
      this.resetEstadoFoto();
    },

    
     
     
      
}
    
      
  
</script>
<style>


p.error { color: red; }

.video-preview {
  width: 100%;
  max-height: 70vh;
  object-fit: cover;
  background: #000;
}

.preview-img {
  width: 100%;
  max-height: 280px;
  object-fit: contain;
  background: #f8f9fa;
}

.modal-camara .modal-dialog {
  max-width: 100vw;
  margin: 0.5rem;
}

.modal-camara-content {
  min-height: 70vh;
}
</style>